import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_f_announce_yellow.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_f_announce.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1ebf2e24")

_pushScopeId("data-v-1ebf2e24")
const _hoisted_1 = { class: "flex flex-col px-3 pb-3" }
const _hoisted_2 = { class: "flex mb-1.5 font-semibold text-black-lp-300 text-12px" }
const _hoisted_3 = { class: "flex flex-row w-full py-1.5 px-3 gap-x-6 rounded-t-md border border-gray-lp-2100 text-gray-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-7 font-semibold text-12px" }, " No ", -1)
const _hoisted_5 = { class: "w-28 font-semibold text-12px" }
const _hoisted_6 = { class: "w-4/12 font-semibold text-12px" }
const _hoisted_7 = { class: "w-36 font-semibold text-12px text-center flex flex-row" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "w-full flex flex-col text-12px" }
const _hoisted_10 = { class: "py-2 font-normal" }
const _hoisted_11 = { class: "custom-list" }
const _hoisted_12 = { class: "w-full border-r border-l border-gray-lp-2100" }
const _hoisted_13 = { class: "flex flex-row items-center gap-x-6 px-3" }
const _hoisted_14 = { class: "w-7 text-14px font-montserrat" }
const _hoisted_15 = { class: "w-28" }
const _hoisted_16 = { class: "w-4/12" }
const _hoisted_17 = { class: "w-36 text-14px font-montserrat" }
const _hoisted_18 = {
  key: 0,
  class: "w-20"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "cursor-pointer w-5",
  src: _imports_0,
  alt: "trash-red"
}, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "w-20"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  class: "cursor-pointer w-5",
  src: _imports_0,
  alt: "trash-red"
}, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row py-1 px-3"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_25 = { class: "text-red-lp-100 text-14px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_26 = {
  key: 1,
  class: "flex flex-row py-1 px-3"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_29 = { class: "text-red-lp-100 text-14px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_30 = {
  key: 2,
  class: "flex flex-row py-1 px-3"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_34 = { class: "text-red-lp-100 text-14px flex pl-1 gap-x-2" }
const _hoisted_35 = {
  key: 1,
  class: "flex flex-row px-4 py-2 rounded-lg bg-yellow-lp-400 items-center"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "announce yellow"
}, null, -1)
const _hoisted_37 = { class: "text-yellow-lp-500 text-14px flex pl-1 gap-x-2" }
const _hoisted_38 = {
  key: 3,
  class: "flex flex-row py-1 px-3"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_41 = { class: "text-red-lp-100 text-14px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_42 = {
  key: 0,
  class: "flex flex-row justify-start px-3 border-b border-gray-lp-2100 pb-1"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_44 = { class: "px-2 py-1 rounded-lg bg-yellow-lp-400 items-center flex flex-row" }
const _hoisted_45 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "announce yellow"
}, null, -1)
const _hoisted_46 = { class: "text-yellow-lp-500 text-14px flex pl-1 gap-x-2" }
const _hoisted_47 = {
  key: 1,
  class: "flex flex-row justify-start px-3"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "w-7 mr-6" }, null, -1)
const _hoisted_49 = { class: "flex flex-row px-4 py-2 rounded-lg mt-4 w-max bg-blue-lp-600 items-center" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mr-2",
  alt: "announce",
  style: {"height":"24px","width":"24px"}
}, null, -1)
const _hoisted_51 = { class: "text-blue-lp-700 text-14px" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "flex flex-row justify-between text-12px py-1.5 px-3 font-semibold rounded-b-md border-b border-l border-r border-gray-lp-2100"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 0,
  class: "flex flex-row justify-between text-12px py-1.5 px-3 font-semibold rounded-b-md border-b border-l border-r border-gray-lp-2100"
}
const _hoisted_56 = {
  key: 2,
  class: "text-red-lp-100 text-12px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, " Total berat melebihi batas maksimum. Cek & atur ulang berat. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
      [_directive_sanitize_html, _ctx.$t('bookingV3.shipment.weightPieces.title')]
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.grossWeight")), 1),
      _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.dimension")), 1),
      _createVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.dimensionWeight")) + " ", 1),
        _createVNode("div", _hoisted_8, [
          _createVNode("img", {
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event))),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltip($event))),
            src: require('@/app/ui/assets/svg/info.svg'),
            alt: "",
            class: "ml-2 w-4"
          }, null, 40, ["src"]),
          _createVNode(_component_OverlayPanel, {
            ref: "opTooltip",
            appendTo: "body",
            class: "w-1/4",
            style: {
              backgroundColor: '#4D4D4D',
              color: '#ffffff'
            }
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.tooltip.title")), 1),
                _createVNode("div", _hoisted_10, [
                  _withDirectives(_createVNode("ul", _hoisted_11, null, 512), [
                    [_directive_sanitize_html, 
                    _ctx.$t('bookingV3.shipment.weightPieces.tooltip.message')
                  ]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPieces, (key, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: ["flex flex-col border-gray-lp-2100", { 'border-b': !_ctx.showWarningHws }]
        }, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, _toDisplayString(index + 1), 1),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_lp_input, {
                ref: `inputGrossWeight${index}`,
                modelValue: key.grossWeight,
                "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), ($event: any) => (_ctx.setOnValidationHws(key.grossWeight, index))],
                format: _ctx.formatFloat,
                onChange: ($event: any) => (_ctx.onChangeGrossWeight(index)),
                placeholder: "0",
                maxLength: _ctx.isMaxLengthGrossWeight,
                error: 
                key.errorHws ||
                  !!key.errorGrossWeight ||
                  _ctx.validateTotalGrossWeight
              ,
                suffix: "kg",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorIndex = _ctx.pieceIndex)),
                disabled: _ctx.getRuleGrossWeightDisabled,
                disabledBackground: _ctx.getRuleGrossWeightDisabled,
                isErrorIconCaption: false,
                isErrorIconInput: false,
                sizeProportional: "py-2",
                "data-testid": `booking-create-input-gross-weight-${index}`
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "onChange", "maxLength", "error", "disabled", "disabledBackground", "data-testid"])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_InputDimension, {
                length: key.dimension.length,
                "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                width: key.dimension.width,
                "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                height: key.dimension.height,
                "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                onChange: _ctx.onChangeVolumeWeight,
                error: 
                key.errorHws ||
                  !!key.errorVolumeWeight ||
                  _ctx.validateTotalVolumeWeight
              ,
                customStyle: "text-14px",
                maxLength: _ctx.isMaxLengthGrossWeight,
                disabled: 
                _ctx.getRuleDimensionDisabled ||
                  !_ctx.enableEditSizeBasedOnWeight(key.grossWeight)
              ,
                withIcon: false,
                sizeProportional: "py-2",
                format: _ctx.formatDimension,
                onFocus: _ctx.setDirty
              }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "onChange", "error", "maxLength", "disabled", "format", "onFocus"])
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(key.convertVolumeWeight) + " kg ", 1),
            (
              _ctx.isShipment
                ? _ctx.dataRuleShipmentBooking.config.adjustPieceRemove.rule ===
                  'EDITABLE'
                : _ctx.configAdjustPieceRemove.rule === 'EDITABLE'
            )
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _withDirectives(_createVNode("button", {
                    onClick: ($event: any) => (_ctx.removeKGs(index)),
                    class: "self-center cursor-pointer ml-3 relative gap-1.5 flex flex-row items-center font-semibold text-red-lp-100 text-14px"
                  }, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.remove")), 1)
                  ], 8, ["onClick"]), [
                    [_vShow, _ctx.isShowButtonDelete && !_ctx.disabledWeight]
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_20, [
                  _withDirectives(_createVNode("button", {
                    onClick: ($event: any) => (_ctx.removeKGs(index)),
                    class: "self-center cursor-pointer ml-3 relative gap-1.5 flex flex-row items-center font-semibold text-red-lp-100 text-14px"
                  }, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.remove")), 1)
                  ], 8, ["onClick"]), [
                    [_vShow, 
                !_ctx.noEditableShipmentCa(index) &&
                  _ctx.isShowButtonDelete &&
                  !_ctx.getRuleAdjustPiece &&
                  !_ctx.disabledWeight
              ]
                  ])
                ]))
          ]),
          (key.errorGrossWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createVNode("p", _hoisted_25, _toDisplayString(key.errorGrossWeight), 1)
              ]))
            : _createCommentVNode("", true),
          (key.errorVolumeWeight && _ctx.isAlreadyErrorMaxWeight(key))
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createVNode("p", _hoisted_29, _toDisplayString(key.errorVolumeWeight), 1)
              ]))
            : _createCommentVNode("", true),
          (key.errorHws)
            ? (_openBlock(), _createBlock("div", _hoisted_30, [
                _hoisted_31,
                (_ctx.totalPieces.length > 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode("p", _hoisted_34, _toDisplayString(`${_ctx.$t("bookingV3.shipment.weightPieces.error.weightAbove")} ${
                  _ctx.configHeavyWeightMinimum.heavyWeightMinimum
                } kg ${_ctx.$t(
                  "bookingV3.shipment.weightPieces.error.prohibitedOnePiece"
                )}`), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("p", _hoisted_37, _toDisplayString(`${_ctx.$t("bookingV3.shipment.weightPieces.weightAbove")} ${
                  _ctx.configHeavyWeightMinimum.heavyWeightMinimum
                } kg${_ctx.$t("bookingV3.shipment.weightPieces.charged")}`), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (
            (_ctx.validateTotalGrossWeight || _ctx.validateTotalVolumeWeight) &&
              !(
                key.errorGrossWeight.includes('400 kg/STT') ||
                key.errorVolumeWeight.includes('400 kg/STT')
              )
          )
            ? (_openBlock(), _createBlock("div", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _createVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.error.maximumWeight")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (_ctx.showWarningHws)
        ? (_openBlock(), _createBlock("div", _hoisted_42, [
            _hoisted_43,
            _createVNode("div", _hoisted_44, [
              _hoisted_45,
              _createVNode("p", _hoisted_46, _toDisplayString(`${_ctx.$t("bookingV3.shipment.weightPieces.weightAbove")} ${
                _ctx.configHeavyWeightMinimum.heavyWeightMinimum
              } kg${_ctx.$t("bookingV3.shipment.weightPieces.charged")}`), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.totalPieces.length > _ctx.maxPieces &&
            !_ctx.interpackLaneResolving &&
            !_ctx.isInterpackLanePending
        )
        ? (_openBlock(), _createBlock("div", _hoisted_47, [
            _hoisted_48,
            _createVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.districtOnePiece")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (
        _ctx.isShipment
          ? _ctx.dataRuleShipmentBooking.config.adjustPieceAdd.rule === 'EDITABLE'
          : _ctx.configAdjustPieceAdd.rule === 'EDITABLE' && _ctx.totalPieces.length < 15
      )
      ? (_openBlock(), _createBlock("div", _hoisted_52, [
          (_ctx.isMaxAddKgs)
            ? (_openBlock(), _createBlock("div", _hoisted_53, [
                _createVNode("button", {
                  disabled: _ctx.disabledWeight,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (
            _ctx.showWarningHws ||
            _ctx.isErrorHws ||
            _ctx.validateTotalGrossWeight ||
            _ctx.validateTotalVolumeWeight ||
            _ctx.disabledWeight
              ? null
              : _ctx.addKGs()
          )),
                  class: 
            `flex gap-3 ${
              _ctx.showWarningHws ||
              _ctx.isErrorHws ||
              _ctx.validateTotalGrossWeight ||
              _ctx.validateTotalVolumeWeight ||
              _ctx.disabledWeight
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-red-lp-300 cursor-pointer'
            }`
          
                }, [
                  _createVNode(_component_Icons, {
                    name: "plus-circle",
                    class: 
              `${
                _ctx.showWarningHws ||
                _ctx.isErrorHws ||
                _ctx.validateTotalGrossWeight ||
                _ctx.validateTotalVolumeWeight ||
                _ctx.disabledWeight
                  ? 'text-gray-lp-600'
                  : 'text-red-lp-100'
              }`
            
                  }, null, 8, ["class"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.addItems")), 1)
                ], 10, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_54, [
          (_ctx.isMaxAddKgs && !_ctx.getRuleAdjustPiece)
            ? (_openBlock(), _createBlock("div", _hoisted_55, [
                _createVNode("button", {
                  disabled: _ctx.disabledWeight,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (
            _ctx.showWarningHws ||
            _ctx.isErrorHws ||
            _ctx.validateTotalGrossWeight ||
            _ctx.validateTotalVolumeWeight ||
            _ctx.disabledWeight
              ? null
              : _ctx.addKGs()
          )),
                  class: 
            `flex gap-3 ${
              _ctx.showWarningHws ||
              _ctx.isErrorHws ||
              _ctx.validateTotalGrossWeight ||
              _ctx.validateTotalVolumeWeight ||
              _ctx.disabledWeight
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-red-lp-300 cursor-pointer'
            }`
          
                }, [
                  _createVNode(_component_Icons, {
                    name: "plus-circle",
                    class: 
              `${
                _ctx.showWarningHws ||
                _ctx.isErrorHws ||
                _ctx.validateTotalGrossWeight ||
                _ctx.validateTotalVolumeWeight ||
                _ctx.disabledWeight
                  ? 'text-gray-lp-600'
                  : 'text-red-lp-100'
              }`
            
                  }, null, 8, ["class"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV3.shipment.weightPieces.addItems")), 1)
                ], 10, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.errorChWeightMaxGapShipmentMp)
      ? (_openBlock(), _createBlock("div", _hoisted_56, [
          _hoisted_57,
          _hoisted_58
        ]))
      : _createCommentVNode("", true)
  ]))
})